import {http} from 'lib/httpAxios'

export default {
  retrieveDocumentStatusData () {
    return http.post(`/order/status`)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error))
  },
  retrieveSupplierCustomerData (parameters) {
    return http.post(`/orders/suppliercustomer/`, parameters)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error))
  },
  retrieveProgressData (parameters) {
    return http.post(`/orders/search/`, parameters)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error))
  }
}



// WEBPACK FOOTER //
// ./src/vuex/api/services/orders.js